import { z } from 'zod';

export const currencyEnum = z.enum(['CZK', 'EUR']);

export type TCurrency = z.infer<typeof currencyEnum>;
